// Import utilities
import { getConditionsGroupById } from '@builder/item/conditions/utilities';
import { itemsObject } from '@builder/common/utilities';
const { isEmpty } = _uo.utility;

/**
 * Checks whether actions should be sortable
 *
 * @param {Object} options The options
 * @param {String} options.conditionsGroupID The condition group ID
 * @param {Integer} options.actionID The action ID
 *
 * @return {Boolean} `true` if they should be sortable
 */
const shouldBeSortable = ( { conditionsGroupID, actionID } ) => {
	// Check if either the conditions group ID or action ID are defined
	if ( isEmpty( conditionsGroupID ) && isEmpty( actionID ) ) {
		// Check if debugging mode is enabled
		// eslint-disable-next-line no-lonely-if
		if ( UncannyAutomatorBackend.debugging.enabled ) {
			// eslint-disable-next-line no-console
			console.warn( `Item/sortability: Define a \`conditionsGroupID\` or \`actionID\`.` );
		}

		return false;
	}

	// Make sure that if the actionID is defined, it's actually an action
	if ( ! isEmpty( actionID ) && UncannyAutomator.recipe.items[ actionID ].itemType !== 'action' ) {
		return;
	}

	// Check if it's a conditions group
	if (
		! isEmpty( conditionsGroupID )
	) {
		// Find conditions group by ID
		const conditionsGroup = getConditionsGroupById( {
			conditionsGroupId: conditionsGroupID,
		} );
		
		// If all its actions are delayed or scheduled, it shouldn't be sortable
		if ( conditionsGroup.hasActions && ! conditionsGroup.hasInstantActions ) {
			return false;
		}
	}

	// // Get information we're going to need
	const quantitySortableActions = Object.values( itemsObject( 'get', {
		filter: {
			itemType: 'action',
			// isScheduled: false,
			// isDelayed: false,
			isMissing: false,
		}
	} ) ).length;

	const quantityConditionsGroups = Object.values( UncannyAutomator.recipe.conditions ).length;

	// This will be sortable if there are at least two items that can be sorted
	return ( quantitySortableActions + quantityConditionsGroups ) > 1;
};

export default shouldBeSortable;
